
import Vue from "vue";

export default Vue.extend({
  name: "SettlementSummaryMetric",
  props: {
    title: { type: String, default: "" },
    value: { type: String, required: true },
    formula: { type: String, default: "" },
    formulaValues: { type: String, default: "" },
    showValue: { type: Boolean, default: true },
    valueInHeader: { type: Boolean, default: false },
    showStatus: { type: Boolean, default: false },
    collapsible: { type: Boolean, default: false },
    initiallyExpanded: { type: Boolean, default: true },
    tone: {
      type: String,
      default: "ink",
      validator: (value: string) => ["ink", "blue", "red"].includes(value),
    },
    surface: { type: Boolean, default: false },
  },
  data() {
    return {
      isExpanded: this.initiallyExpanded,
    };
  },
  computed: {
    contentVisible(): boolean {
      return !this.collapsible || this.isExpanded;
    },
    metricClasses(): Record<string, boolean> {
      return {
        "is-surface": this.surface,
        "is-blue": this.tone === "blue",
        "is-red": this.tone === "red",
        "is-collapsed": this.collapsible && !this.isExpanded,
      };
    },
  },
  methods: {
    toggleExpanded(): void {
      this.isExpanded = !this.isExpanded;
    },
  },
});
